<template>
  <section class="error-page">
    <div class="error-page__sim-img-wrapper">
      <img
        class="error-page__sim-img"
        src="@/assets/images/error-handling/sim-oh-dip.png"
      />
    </div>
    <div class="error-page__errors-wrapper">
      <div class="error-page__errors">
        <h5 class="error-page__error-name">{{ errorHeader }}</h5>
        <p class="error-page__error-msg">{{ errorMsg }}</p>
        <p class="error-page__lead lead">Server Response</p>
        <p
          v-if="serverError !== ''"
          class="error-page__server-error"
          v-html="serverError"
        ></p>
        <p v-if="noSubscription" class="error-page__subscription-notice">
          Please visit
          <a
            class="error-page__ine-link"
            href="https://ine.com/pages/all-access-pass"
            >INE All Access Pass</a
          >
          to update your subscription.
        </p>
      </div>
    </div>
    <div class="error-page__action-buttons-wrapper">
      <a
        class="error-page__action-button"
        href="https://ine.com/pages/contact-us"
        >Contact Us</a
      >
      <router-link
        v-if="!isAuthenticated || authError"
        class="error-page__action-button"
        :to="{ name: 'login' }"
        >Login</router-link
      >
      <router-link class="error-page__action-button" :to="{ name: 'home' }"
        >Return Home</router-link
      >
      <button class="error-page__action-button" @click="$router.go(-1)">
        Go Back!
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ErrorHandling',
  data() {
    return {
      errorHeader: '',
      errorMsg: '',
      serverError: '',
      noSubscription: false,
      authError: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  methods: {
    generateErrorMsg() {
      switch (this.$route.params.status) {
        case 400:
          this.$store.dispatch('auth/logout')
          this.errorHeader = 'Oh Snap!'
          this.errorMsg =
            'Your session validation failed for an unknown reason. Please log in.'
          this.authError = true
          break
        case 401:
          this.$store.dispatch('auth/logout')
          this.errorHeader = 'Oopsie Daisy!'
          this.errorMsg =
            'Your session has expired. Please log in. Please contact us if the problem persists.'
          this.authError = true
          break
        case 402:
          this.errorHeader = 'Oh Dip!'
          this.errorMsg = 'You need an active subscription to continue.'
          this.noSubscription = true
          break
        case 403:
          this.$store.dispatch('auth/logout')
          this.errorHeader = 'Oopsie Daisy!'
          this.errorMsg =
            'Your session has expired. Please log in. Please contact us if the problem persists.'
          this.authError = true
          break
        default:
          this.errorHeader = 'Oops!'
          this.errorMsg =
            "There was an issue on our server. We're sorry about that. Please try again or contact us if the problem persists."
      }
    },
    checkForServerError() {
      if (
        this.$route.params.response &&
        this.$route.params.response.data &&
        this.$route.params.response.data.error
      ) {
        this.serverError = this.$route.params.response.data.error.message
      } else if (
        this.$route.params.message &&
        this.$route.params.message.length
      ) {
        this.serverError = this.$route.params.message
      }
    },
  },
  created() {
    this.generateErrorMsg()
    this.checkForServerError()
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.error-page {
  min-height: 100vh;
  padding: 150px 0;
  margin: 0 auto;
  text-align: center;
  &__sim-img-wrapper {
    margin-bottom: 50px;
  }
  &__sim-img {
    height: 250px;
  }
  &__errors {
    color: var(--white);
  }
  &__error-name {
    text-transform: uppercase;
    font-weight: 700;
    margin: 0;
  }
  &__error-msg {
    font-size: 1.1rem;
    font-weight: 500;
    margin: 25px 0;
  }
  &__lead {
    margin: 20px 0;
  }
  &__server-error {
    color: var(--white);
    font-size: 1rem;
  }
  &__subscription-notice {
    font-size: 1.3rem;
  }
  &__ine-link {
    color: var(--orange);
    margin-bottom: 20px;
    transition: 0.5s all ease;
    &:hover {
      color: var(--white);
    }
  }
  &__action-buttons-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    @include mobile {
      justify-content: center;
    }
  }
  &__action-button {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: var(--white);
    font-size: 1rem;
    text-transform: uppercase;
    border: 1.4px solid var(--orange);
    padding: 5px 20px;
    border-radius: 30px;
    transition: 0.5s all ease;
    background: transparent;
    margin: 10px 25px;
    &:hover {
      cursor: pointer;
      color: var(--black);
      background-color: var(--white);
    }
  }
}
</style>
